export default __webpack_public_path__ + "static/media/logo.c47343db.svg";